// extracted by mini-css-extract-plugin
module.exports = {"content":"certificates_content__31Vw3","description":"certificates_description__2W21z","certificate_img":"certificates_certificate_img__1n8p6"};